import { sportList, sportListApi } from './sports.const';
import { getArrayKeyByValue } from 'utils/formatter';

export const formatSport = (api: sportListApi): sportList => {
  const key = getArrayKeyByValue(sportListApi, api);
  return sportList[key || 0];
};
